import { ThemeOptions } from '../components/ThemeProvider/ThemeOptions';
import {
	AuxiliaryDanger,
	AuxiliarySuccess,
	AuxiliaryWarning,
	ColdNeutral,
	PixidaBlue,
	white,
} from '../colors';
import { pixidaLogo } from '../logos';

export const pixidaTheme: ThemeOptions = {
	name: 'pixida',
	logo: pixidaLogo,
	palette: {
		primary: {
			main: PixidaBlue[500],
			contrastText: white,
		},
		info: {
			main: ColdNeutral[200],
			contrastText: white,
		},
		success: {
			main: AuxiliarySuccess[500],
			contrastText: white,
		},
		warning: {
			main: AuxiliaryWarning[500],
			contrastText: white,
		},
		error: {
			main: AuxiliaryDanger[700],
			contrastText: white,
		},
	},
};
